<template>
  <a class="news__news-box-link" :href="`/announcements/${newsId}`">
    <div class="news__news-box">
      <div class="news__news-box__text">
        <p class="news__news-box__date">
          {{ startedAt }}
        </p>
        <p class="news__news-box__title">
          {{ newsTitle }}
        </p>
      </div>
    </div>
  </a>
</template>
<script>
export default {
  props: {
    newsId: {
      type: Number,
      required: true
    },
    newsTitle: {
      type: String,
      required: true
    },
    startedAt: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss" scoped>
.news {
  &__news-box-link {
    width: 100%;
    margin-bottom: 16px;
    height: 54px;
  }

  &__news-box-link:last-child {
    margin-bottom: 0;
  }

  &__news-box {
    display: flex;
    height: 100%;
    align-items: center;

    &__text {
      display: flex;
      flex-direction: column;
      text-align: left;
      width: 100%;
    }

    &__date {
      font-size: 1rem;
      line-height: 1.6;
      color: $gray-1;
    }

    &__title {
      font-size: 1.2rem;
      line-height: 1.6;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      color: $black;
    }
  }
}
</style>
